import { PARTNER_TYPES, PROFILE_TYPES, RECORD_TYPE } from '@/app/data/model_constants';

const CONTACT_TYPE_TO_ICON = Object.freeze({
  [PARTNER_TYPES.DECISION_PARTNER]: 'regular-person-dolly',
  [PARTNER_TYPES.PROJECT_PARTNER]: 'regular-user-helmet-safety',
  [PROFILE_TYPES.CUSTOMER]: 'regular-user-large',
  [PROFILE_TYPES.EMPLOYEE]: 'regular-user-group',
  [PROFILE_TYPES.PARTNER]: 'solid-users',
  [RECORD_TYPE.COMPANY]: 'solid-building',
});

export default CONTACT_TYPE_TO_ICON;
